export const getGeneralSettings = (state) => state.generalSettings